module.exports = __webpack_public_path__ + "img/offline.6945d493.png";